import { useOnClose } from 'js/components/common/PopupManager';
import { LOGIN_POPUP_ID } from 'js/components/popups/LoginPopup/buzz/constants';

export const useCloseLoginPopup = () => useOnClose(LOGIN_POPUP_ID);
